import { useWeb3React } from "@web3-react/core";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { NETWORKS } from "./utils/constants";
import { useEagerConnect, useInactiveListener } from "./hooks";
import LandingHeader from "./Components/LandingPage/LandingHeader";
import Dashboard from "./Dashboard";
import LandingFooter from "./Components/LandingPage/LandingFooter";

function App() {
    const { chainId } = useWeb3React();
    const [searchParams, setSearchParams] = useSearchParams();
    const triedEager = useEagerConnect();
    useInactiveListener(!triedEager);
    useEffect(() => {
        let updatedSearchParams = new URLSearchParams(searchParams.toString());
        // console.log(NETWORKS[chainId]?.name, chainId);
        updatedSearchParams.set(
            "chain",
            chainId ? NETWORKS[chainId]?.name : "bsc"
        );
        setSearchParams(updatedSearchParams.toString());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chainId, searchParams]);

    return (
        <div className="d-flex animation-fade-in bg-kadDarkBg text-white">
            <LandingHeader />
            <Dashboard />
            <LandingFooter />
        </div>
    );
}

export default App;
